import * as React from "react";
import {resourcesHelper} from "@falcon/services";
import { scrollToTop } from "../../CommonFunctions";
import {IWithRouterProps, withRouter} from "@athena-portal/components";

interface IProps {
    policyHolder: any;
    policy: any;
}

export class QuickQuoteBannerPlain extends React.Component<IProps & IWithRouterProps> {

    public render() {
        const policyHolder: any = this.props.policyHolder;
        const address: string = policyHolder.address.addressLine1 + ", "
            + policyHolder.address.town + ", " + policyHolder.address.postalCode;

        return <div className="quick-quote-banner-block">
            <div className="quick-quote-banner-image">
                <img className="image d-desktop-none"
                     src={`/${resourcesHelper.THEME}/img/care-image-mobile.jpeg`} alt="care"/>
                <img className="image d-mobile-none"
                     src={`/${resourcesHelper.THEME}/img/care-image.jpg`} alt="care"/>
            </div>
            <div className="quick-quote-banner">
                <p className="mb-3 fs-32 mt-4">Protect your happy place with</p>
                <p className="mb-3 green-color fs-32">{resourcesHelper.PRODUCT} Home Insurance</p>
                <p className="mb-4 fs-32">Get a quote in just 12 questions</p>

                <p className="mb-1">Address: <span className="font-weight-semi-bold"> {address}</span></p>
                <p className="mb-1">Cover type: <span className="font-weight-semi-bold"> Buildings & contents insurance</span></p>
                <p>Policyholder: <span className="font-weight-semi-bold"> {policyHolder.firstName} {policyHolder.lastName}</span></p>

                <button type="button" className="btn-blue-dashboard btn-primary mb-3 mt-4"
                        onClick={this.navigateToQuickQuotePresetPage()}>
                    Get your home quote
                </button>
            </div>
        </div>
    }

    private navigateToQuickQuotePresetPage() {
        return () => {
            this.props.navigate("/journey/show/product/AnnualHomeInsurance/process/nb/quickQuotePresetPage", this.props.policy);
            scrollToTop();
        }
    }
}

export const QuickQuoteBanner = withRouter<IProps>(QuickQuoteBannerPlain)
